import { Typography } from 'antd';
import TeladocIcon from 'assets/images/teladoc.svg';
import { StyledTitle } from 'components/StyledTitle';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
const { Text } = Typography;

const Wrapper = styled.div`
  padding: 24px;
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  align-items: flex-start;
  cursor: pointer;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const TelaDocItem = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleOnClick = () => {
    navigate('/teladoc-booking');
  };
  return (
    <Wrapper onClick={handleOnClick}>
      <TextWrapper>
        <StyledTitle level={5}>{t('teladoc.bannerHeading')}</StyledTitle>
        <StyledTitle level={4}>{t('teladoc.card.title')}</StyledTitle>
        <Text type="secondary">{t('teladoc.card.description')}</Text>
      </TextWrapper>
      <img src={TeladocIcon} alt="teladocIcon" width="44px" />
    </Wrapper>
  );
};

export default TelaDocItem;
